/* eslint-disable camelcase */
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import CsvDownloader from 'react-csv-downloader';
import { sess_get } from '../../../utils/HttpRequests';
import SearchVMNManagement from './SearchVMNManagement';
import './VMNManagement.css';

const SearchAvailableNumbers = () => {
  const [searchValue, setSearchValue] = useState('');
  const [isPremium, setIsPremium] = useState(false);
  const [error, setError] = useState('');
  const [similarVMNs, setSimilarVMNS] = useState([]);
  const [matchedVMNS, setMatchedVMNS] = useState([]);

  const searchVMNs = async () => {
    try {
      const sessionToken = localStorage.getItem('admin-panel-sessionToken');
      let url = 'admin/console/similar-matches-vnms?';
      if (!searchValue) {
        setError('Phone number is required');
        return;
      }
      if (searchValue) {
        url = `${url}phone_number=${searchValue}`;
      }
      if (isPremium !== '' && isPremium !== undefined) {
        url = `${url}&only_premium=${isPremium}`;
      }
      setError('');
      const searchVMNSResponse = await sess_get(url, sessionToken);
      setSimilarVMNS(searchVMNSResponse?.data?.response?.nearest_matches);
      setMatchedVMNS(searchVMNSResponse?.data?.response?.regex_matches);
    } catch (err) {
      setError(err?.response?.data?.error?.reason || err.message || 'something went wrong in update category price');
    }
  };
  const similarVMNsHTML = similarVMNs.map((vmn) => (
    <tr>
      <td>
        {vmn.v_mobile_no}
      </td>
      <td>
        {`${vmn.is_premium}`}
      </td>
      <td>
        {vmn.price / 100}
      </td>
    </tr>
  ));
  const matchedVMNsHTML = matchedVMNS.map((vmn) => (
    <tr>
      <td>
        {vmn.v_mobile_no}
      </td>
      <td>
        {`${vmn.is_premium}`}
      </td>
      <td>
        {vmn.price / 100}
      </td>
    </tr>
  ));
  return (
    <div style={{ textAlign: 'center', fontWeight: 'bolder' }}>
      <form className="form-horizontal">
        <div className="container">
          <div className="label">Doosra VMN Numbers</div>
          <div className="label" style={{ marginBottom: 15 }}>Search for available numbers</div>
          <div className="inputs-fl-1">
            <span>
              Show only premium
              {' '}
              <input type="checkbox" name="premium" value={isPremium} onChange={() => setIsPremium(!isPremium)} />
              {' '}
            </span>

          </div>
          <div className="inputs-fl-2">
            <input
              className="form-control"
              type="text"
              placeholder="Search..."
              value={searchValue}
              onChange={(e) => {
                setSimilarVMNS([]);
                setMatchedVMNS([]);
                setSearchValue(e.target.value);
              }}
            />
          </div>
          <div className="inputs-fl-1">
            <Button variant="danger" onClick={searchVMNs}>Search for VMN</Button>
          </div>
          <div className="inputs-fl-1">
            {/* <Button variant="danger">Upload</Button> */}
            <SearchVMNManagement title="Choose VMN's CSV File" name="Upload" url="admin/console/insert-vmns" vmn="doosra" />
          </div>
          <div className="inputs-fl-1">
            <SearchVMNManagement title="Choose VMN's prices CSV File" name="Manage" url="admin/console/update-vmns-price" vmn="doosra" />
          </div>
          <div className="inputs-fl-1">
            <SearchVMNManagement title="Choose VMN's CSV File" name="Delete" method="delete" url="admin/console/vmns" vmn="doosra" />
          </div>
          <div className="inputs-fl-1">

            <CsvDownloader
              style={{
                cursor: 'pointer',
                color: '#337ab7',
                textDecoration: 'none',
              }}
              filename="Doosra VMNs"
              // text="Sample File"
              datas={[
                {
                  number: 'number - 10 digits',
                  is_premium: 'is_premium - true/false',
                  is_vip: 'is_vip - true/false',
                  price: 'price - in rupees',
                },
              ]}
            >
              <a style={{
                cursor: 'pointer',
                color: '#337ab7',
                textDecoration: 'none',
              }}
              >
                Sample file
              </a>
            </CsvDownloader>
          </div>
          {error && (
            <div className="label" style={{ color: 'red' }}>
              {error}
            </div>
          )}
          {(matchedVMNS.length > 0 || similarVMNs.length > 0) && (
            <div className="label" style={{ display: 'flex', justifyContent: 'space-between', padding: '1%' }}>
              <div style={{ flex: '1 1 0' }}>
                <div style={{ textAlign: 'center', fontWeight: 'bolder', margin: '1%' }}>
                  Matched VMNs
                </div>
                <div className="vmns-search">
                  <table style={{ width: '90%' }}>
                    <thead>
                      <tr>
                        <th scope="col">
                          <center>
                            VMN
                          </center>
                        </th>
                        <th scope="col">
                          <center>
                            Is Premium
                          </center>
                        </th>
                        <th scope="col">
                          <center>
                            Price
                          </center>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {matchedVMNsHTML}
                    </tbody>
                  </table>
                </div>
              </div>

              <div style={{ flex: '1 1 0' }}>
                <div style={{ textAlign: 'center', fontWeight: 'bolder', margin: '1%' }}>
                  Similar VMNs
                </div>
                <div className="vmns-search">
                  <table style={{ width: '90%', paddingRight: '1%' }}>
                    <thead>
                      <tr>
                        <th scope="col">
                          <center>
                            VMN
                          </center>
                        </th>
                        <th scope="col">
                          <center>
                            Is Premium
                          </center>
                        </th>
                        <th scope="col">
                          <center>
                            Price
                          </center>
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {similarVMNsHTML}
                    </tbody>

                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </form>
    </div>

  );
};
export default SearchAvailableNumbers;
